import FeeInvoiceModel from '../models/fee-invoice.model';

let storeContent = utils.generateStore({
	FeeInvoiceModel,
	invoices: [],
	selected_invoice: null,
	invoice_details: null,
	showInvoice: false,
	invoice_breakdown: null,
	lender_details: null,
	invoice_system_ref: null,
	payment_breakdown: [],
	lenders: [],
	bank_payment_schedule: [],
	simulated_loan_details: null,
	selected_lender: null,
	application_system_ref: null,
	schedule_details: [],
	schedule_summary_details: null,
	loan_config_details: null,
	loan_application_details: null,
	get_finance_data: null,
	account_details: null,
	selected_lender_id: '0',
	showPaymentBreakdown: false,
	showMakePayment: false,
	showRequestFinance: false,
	acc_balance: 0,
	acc_balance_currency: 0,
	current_finance_page: 1,
	ads: [],
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		async navigateNextStepInvoice(ctx, payload) {
			try {
				ctx.commit('loading', true);
				if (ctx.getters.current_finance_page == 1) {
					if (await payload.request_finance.isValid()) {
						await ctx.dispatch('createInvoiceFinance', payload);
					}
				} else if (ctx.getters.current_finance_page == 2) {
					if (ctx.getters.selected_lender_id) {
						await ctx.dispatch('fetchLenderDetails');
						ctx.commit('current_finance_page', 3);
					} else {
						$notify(
							'warning',
							'Select Lender',
							`Select a lender to continue`,
							3,
						);
					}
				} else if (ctx.getters.current_finance_page == 3) {
					await ctx.dispatch('fetchLoanPaymentDetails');
					ctx.commit('current_finance_page', 4);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async fetchLoanPaymentDetails(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'invoice_financing',
						action: 'generate_offer',
						data: {
							// invoice_system_ref: ctx.getters.invoice_system_ref,
							application_system_ref:
								ctx.getters.application_system_ref,
							loan_product_system_ref:
								ctx.getters.selected_lender
									.loan_product_system_ref,
						},
					},
					'/client',
				);

				ctx.commit(
					'schedule_details',
					res.result.loan_offer_details.loan_schedule,
				);
				ctx.commit(
					'application_charges',
					res.result.loan_offer_details.charges,
				);
				ctx.commit(
					'schedule_summary_details',
					res.result.loan_offer_details.loan_summary,
				);
				ctx.commit(
					'loan_application_details',
					res.result.loan_offer_details.application_details,
				);
				await ctx.dispatch(
					'fetchPaymentOptions',
					res.result.loan_offer_details.invoice_details,
				);
			} catch (err) {
				throw err;
			}
		},
		async fetchLenderDetails(ctx, payload) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'invoice_financing',
						action: 'product_details',
						data: {
							loan_product_system_ref:
								ctx.getters.selected_lender
									.loan_product_system_ref,
						},
					},
					'/client',
				);

				ctx.commit('lender_details', res.result);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async createInvoiceFinance(ctx, payload) {
			try {
				let data = payload.request_finance.formData_;
				ctx.commit(
					'invoice_system_ref',
					ctx.getters.invoice_details.invoice_system_ref,
				);

				if (data.amount > ctx.getters.invoice_details.invoice_amount) {
					$notify(
						'warning',
						'Amount Exceeds',
						`Amount provided exceeds the invoice amount`,
						6,
					);
					return false;
				}
				if (
					ctx.getters.get_finance_data &&
					data.amount >
						ctx.getters.invoice_details.invoice_finance_option
							.amt_available_for_finance
				) {
					$notify(
						'warning',
						'Amount Exceeds',
						`Amount provided exceeds the available finance amount`,
						10,
					);
					return false;
				}

				let res = await api.fetchEndpointSecure(
					{
						resource: 'invoice_financing',
						action: 'create',
						data: {
							invoice_system_ref: ctx.getters.invoice_system_ref,
							amount: data.amount,
							term: data.period,
							preffered_repayment_date:
								data.preferred_payment_date,
						},
					},
					'/client',
				);

				ctx.commit(
					'application_system_ref',
					res.result.application_system_ref,
				);
				await ctx.dispatch(
					'fetchLenders',
					res.result.application_system_ref,
				);
				ctx.commit('current_finance_page', 2);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async acceptFinancing(ctx, payload) {
			try {
				ctx.commit('loading', true);

				if (
					(await payload.accept_bank.isValid()) &&
					(await payload.loan_payment_options.isValid())
				) {
					let res = await api.fetchEndpointSecure(
						{
							resource: 'invoice_financing',
							action: 'accept_offer',
							data: {
								// invoice_system_ref: ctx.getters.invoice_system_ref,
								application_system_ref:
									ctx.getters.application_system_ref,
								loan_product_system_ref:
									ctx.getters.selected_lender
										.loan_product_system_ref,
								loan_product_tnc_ref:
									ctx.getters.selected_lender
										.loan_product_tnc_ref,
								system_tnc_ref: 'test-1',
								repayment_options: [], //payload.loan_payment_options.formData_.payment_option.length > 0 ? payload.loan_payment_options.formData_.payment_option.map((el) => {return el.ClientTopupOption_id}): [],
							},
						},
						'/client',
					);

					await ctx.dispatch('fetchSchoolsInvoices');
					ctx.commit('showRequestFinance', false);
					ctx.commit('showMakePayment', false);
					ctx.commit('showInvoice', false);
					ctx.commit('current_finance_page', 1);
					$notify(
						'success',
						'Financing Requested',
						`Financing successfully requested for invoice: <b class="tx-uppercase">${ctx.getters.invoice_system_ref}</b>. Financing is currently being processed.`,
						10,
					);
					// await ctx.dispatch('fetchPaymentBreakdown')
					// ctx.commit('showPaymentBreakdown', true)
				}
				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async rejectFinancing(ctx, payload) {
			try {
				ctx.commit('loading', true);

				// if (await payload.accept_bank.isValid()) {
				//    let res = await api.fetchEndpointSecure({
				//       resource: "invoice_financing",
				//       action: "accept",
				//       data: {
				//          invoice_system_ref: ctx.getters.invoice_system_ref,
				//          application_system_ref: ctx.getters.application_system_ref,
				//          // loan_product_system_ref: ctx.getters.selected_lender.loan_product_details.product_system_ref,
				//          loan_product_system_ref: ctx.getters.selected_lender_id,
				//          loan_product_tnc: true,
				//          repayment_options: [1,3],
				//       }
				//    }, '/client')

				//    await ctx.dispatch('fetchSchoolsInvoices')
				//    // await ctx.dispatch('fetchPaymentBreakdown')
				//    // ctx.commit('showPaymentBreakdown', true)
				// }

				ctx.commit('showRequestFinance', false);
				ctx.commit('showMakePayment', false);
				ctx.commit('showInvoice', false);
				ctx.commit('current_finance_page', 1);
				$notify(
					'warning',
					'Financing Rejected',
					`Financing for invoice: <b class="tx-uppercase">${ctx.getters.invoice_system_ref} rejected.</b>`,
					10,
				);
				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async fetchPaymentDetails(ctx, account_number) {
			try {
				Event.$emit('loader:show', true);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'account',
						action: 'details',
						data: { account_number },
					},
					'/client',
				);

				if (res.result) {
					ctx.commit(
						'acc_balance_currency',
						res.result.currency_code,
					);
					ctx.commit('acc_balance', res.result.available_balance);
				}

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchLenders(ctx, application_ref) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'invoice_financing',
						action: 'loan_products',
						data: {
							application_system_ref: application_ref,
						},
					},
					'/client',
				);

				ctx.commit('current_finance_page', 1);
				//console.log(" ==== Lenders ==== ",res.result)
				if (res.result.loan_products) {
					ctx.commit('lenders', res.result.loan_products);
				}
			} catch (err) {
				throw err;
			}
		},
		async fetchInvoices(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'invoices',
						action: 'to_entity',
						data: {},
					},
					'/client',
				);
				//console.log("  client invoices ==== ",res.result)
				ctx.commit('invoices', res.result.invoices);
			} catch (err) {
				throw err;
			}
		},
		async fetchData(ctx) {
			try {
				await ctx.dispatch('fetchInvoices');
				// await ctx.dispatch('fetchSponsoredAds')
				Event.$emit('loader:show', false);
			} catch (err) {
				throw err;
			}
		},
		async fetchInvoiceDetails(ctx, payload) {
			try {
				Event.$emit('loader:show', true);
				ctx.commit('selected_invoice', payload.invoice);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'invoices',
						action: 'view',
						data: {
							invoice_system_ref:
								payload.invoice.invoice_system_ref,
						},
					},
					'/client',
				);

				let actres = await api.fetchEndpointSecure(
					{
						resource: 'account',
						action: 'details',
						data: {
							account_number:
								res.result.invoice.to_entity.account_number,
						},
					},
					'/client',
				);

				//  console.log(" === Account details === ",actres.result)
				if (res.result.invoice) {
					if (actres.result) {
						ctx.commit('account_details', actres.result);
					}
					ctx.commit('invoice_details', res.result.invoice);
					ctx.commit('showInvoice', true);
				}

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchPaymentDetails(ctx, account_number) {
			try {
				Event.$emit('loader:show', true);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'account',
						action: 'details',
						data: { account_number },
					},
					'/client',
				);

				if (res.result) {
					ctx.commit(
						'acc_balance_currency',
						res.result.currency_code,
					);
					ctx.commit('acc_balance', res.result.available_balance);
				}

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchSponsoredAds(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'sponsored_ads',
						action: 'get',
						data: {},
					},
					'/client',
				);

				ctx.commit('ads', res.result);
			} catch (err) {
				throw err;
			}
		},
		async showMakePayment(ctx) {
			try {
				if (ctx.getters.invoice_details) {
					await ctx.dispatch(
						'fetchPaymentDetails',
						ctx.getters.invoice_details.to_entity.account_number,
					);
				}
				ctx.commit('showMakePayment', true);
			} catch (err) {
				throw err;
			}
		},
		async openRequestInvoiceFinance(ctx, { accept_terms }) {
			try {
				if (await accept_terms.isValid()) {
					let model = FeeInvoiceModel;

					model.forms.request_finance.data.amount = Math.round(
						ctx.getters.invoice_details.invoice_finance_option
							.amt_available_for_finance,
					);
					ctx.commit('FeeInvoiceModel', model);
					Event.$emit('loader:show', true);
					await ctx.dispatch('fetchLoanConfigDetails');
					ctx.commit('showRequestFinance', true);
					Event.$emit('loader:show', false);
				}
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async payInvoice(ctx, invoice_system_ref) {
			try {
				ctx.commit(
					'invoice_system_ref',
					ctx.getters.invoice_details.invoice_system_ref,
				);

				Event.$emit('loader:show', true);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'invoice',
						action: 'payment_request',
						data: {
							invoice_system_ref: ctx.getters.invoice_system_ref,
						},
					},
					'/client',
				);

				if (res.result) {
					// await ctx.dispatch('fetchSchoolsInvoices')
					ctx.commit('showRequestFinance', false);
					ctx.commit('showMakePayment', false);
					ctx.commit('showInvoice', false);
					//ctx.commit('showInvoice', false)
					$notify(
						'success',
						'Invoice Paid',
						`Invoice: <b class="tx-uppercase">${ctx.getters.invoice_system_ref}</b> successfully paid.`,
						10,
					);
				}
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchLoanConfigDetails(ctx) {
			try {
				// let res = await api.fetchEndpointSecure({
				//    resource: "invoice_financing",
				//    action: "config",
				//    data: {
				//       config_type: "school",
				//    }
				// }, '/client')

				// if(res.result){
				let model = FeeInvoiceModel;
				model.forms.request_finance.forms[1].min = 1;
				model.forms.request_finance.forms[1].max =
					ctx.getters.invoice_details.invoice_finance_option.max_loan_tenor;
				model.forms.request_finance.data.period = 1;
				ctx.commit('FeeInvoiceModel', model);
				// }
			} catch (err) {
				throw err;
			}
		},
	},
};
